module.exports = __webpack_public_path__ + "img/normal.15b5e748.svg";